import { render, staticRenderFns } from "./yxqnAlert.vue?vue&type=template&id=1032293c&scoped=true"
import script from "./yxqnAlert.vue?vue&type=script&lang=js"
export * from "./yxqnAlert.vue?vue&type=script&lang=js"
import style0 from "./yxqnAlert.vue?vue&type=style&index=0&id=1032293c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1032293c",
  null
  
)

export default component.exports